<template>
     <div class="homePage">
    <div class="homePage-first5">
        <div class="homePage-first">
        <div class="first-content">
          <div class="content-img">
              <img src="@/assets/image/diantu.png" alt="">
              <div style="margin-left:45px;margin-top:2px">
                  <p><span style="font-size:32px;color: #262A47;">视频会议</span></p>
                  <p style="width: 461px;font-size: 20px;color: #656B90;line-height: 36px;margin-top:10px">私有化部署、全平台支持，服务器端可根据客户需要部署在云服务器、局域网内Linux、Windows操作系统，软硬件客户端全平台适配，按需安装，满足各种场景的需要。</p>
                  <div style="margin-top:15px">
                    <img src="@/assets/image/duotu.png" alt="">
                  </div>
              </div>
          </div>
        </div>
    </div>
    <div style="background-color:#EBF3FE;height: 600px;">
        <div class="first-content5" style="padding-top: 50px;">
          <div class="content-img5">
            <div style="width:459px;display: flex; flex-direction: column;justify-content: center;">
                  <div style="width:500px;">
                      <span style="font-size: 32px;color: #262A47;">视频会议SDK</span>
                  </div>
                  <div style="margin-top:15px">
                      <p style="font-size: 20px;color: #656B90;line-height: 36px;">提供服务器集成API和各个客户端的集成SDK，让第三方伙伴可以无缝集成系统，实现一对一和多方音视频对话，多方视频会议，远程调度等能力，与合作伙伴共同打造行业解决方案和应用。</p>
                  </div>
              </div>
              <img src="@/assets/image/zhibo.png" alt="">
          </div>
        </div>
    </div>
    </div>
    <div class="homePage-first4">
        <div class="first-content4">
          <div class="content-img4">
            <img src="@/assets/image/wutu.png" alt="" style="margin-top:35px"> 
              <div style="width:459px;display: flex; flex-direction: column;justify-content: center;">
                  <div>
                      <span style="font-size: 32px;color: #262A47;">Web会议接入</span>
                  </div>
                  <div style="margin-top:15px">
                      <p style="font-size: 20px;color: #656B90;line-height: 36px;">基于WebRTC，支持Web端接入，支持PC端、移动端，提供SDK接口，无需安装客户端和插件，更易于与业务系统结合。</p>
                  </div>
              </div>
          </div>
        </div>
    </div>
    <div class="homePage-first8">
        <div class="first-content8">
          <div class="content-img8">
              <div style="width:459px;display: flex; flex-direction: column;justify-content: center;">
                  <div>
                      <span style="font-size: 32px;color: #262A47;">互动直播</span>
                  </div>
                  <div style="margin-top:15px">
                      <p style="font-size: 20px;color: #656B90;line-height: 36px;">支持会议中进行同步直播，让大量用户可以直接浏览器或移动端在线实时收看直播画面并进行文字交流。</p>
                  </div>
              </div>
             <img src="@/assets/image/wutu1.png" alt="" style="margin-top:35px"> 
          </div>
        </div>
    </div>
    <div class="homePage-first7">
        <div class="first-content7">
          <div class="content-img7">
              <img src="@/assets/image/huizhong.png" alt="">
              <div style="width:459px;display: flex; flex-direction: column;justify-content: center;margin-left:110px">
                  <div style="width:500px;">
                      <span style="font-size: 32px;color: #262A47;">H323/SIP网关</span>
                  </div>
                  <div style="margin-top:15px">
                      <p style="font-size: 20px;color: #656B90;line-height: 36px;">通过H323/SIP网关，红杉会议可以无缝对接客户已有的硬件视频会议终端和MCU，支持双向的呼入和呼出，兼容现有华为、宝利通、科达、中兴、思科、Yealink等主流产品。</p>
                  </div>
              </div>
          </div>
        </div>
    </div>
    <!-- <div class="homePage-first4">
        <div class="first-content4">
          <div class="content-img4">
            <img src="@/assets/image/wutu.png" alt="" style="margin-top:35px"> 
              <div style="width:459px;display: flex; flex-direction: column;justify-content: center;">
                  <div>
                      <span style="font-size: 32px;color: #262A47;">Web会议接入</span>
                  </div>
                  <div style="margin-top:15px">
                      <p style="font-size: 20px;color: #656B90;line-height: 36px;">基于WebRTC，支持Web端接入，支持PC端、移动端，提供SDK接口，无需安装客户端和插件，更易于与业务系统结合。</p>
                  </div>
              </div>
          </div>
        </div>
    </div> -->
    <div class="homePage-first6">
        <div class="first-content6">
          <div class="content-img6">
          <el-carousel :interval="2000"  arrow="always"  style="padding-top: 35px;">
           <el-carousel-item class="el-car-item" v-for="(list, index) in getLunbo" :key="index">
            <img v-for="(imgList,index2) in list" :key="index2" class="top-img" :src="imgList.url" :alt="imgList.title" style="display:inline-block"/>
             </el-carousel-item>
            </el-carousel>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
    data(){
        return{
            getLunbo:[
                {
                    url:'http://g.hongshantong.com/upload/webuploader/da6a1ac4-defe-9bf2-4669-d512c92635b3.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/1f287b26-ee7d-6450-8144-b36eb26313c0.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/3cb3e07d-6655-0f2b-40b2-c22d2a049a19.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/98d54bd6-2e73-53d0-5fc0-ffdbbcc4e059.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/93effc22-2698-1097-9956-d1f60cae28c9.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638536865065.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638548137390.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638549494694.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638544503994.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638549228836.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/6edfee6d-8233-6fa1-6d00-d674a484f265.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638541229615.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/0c29fe28-c88c-3c10-5c12-66320bcd07ac.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/20190430163854187567.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638543588081.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638546767255.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/20190430163854812984.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638544370844.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638549284743.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638542069985.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638545707266.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638544776763.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638542244248.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638544811337.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638532668602.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638532037140.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638538364947.png'
                },
                
                   {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638539038020.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638539876887.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638537360069.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/20190430163853489285.png'
                },
               
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638538355125.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638539661623.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/1cb29d8b-47ed-b3e1-8cd8-825aca188134.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/99ba1554-5ee3-66db-fb8c-9b106107d82f.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/baeeaca4-0344-92aa-bd87-2695c6958625.png'
                },

                {
                    url:'http://g.hongshantong.com/upload/webuploader/201904301638532937425.png'
                },

                 {
                    url:'http://g.hongshantong.com/upload/webuploader/61fd7b23-c9f5-c51e-afe8-cf5188bc5292.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/2f72c07c-4f74-e21e-a82e-4ee8c8a34061.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/7289d4da-42cb-8dd7-2012-62de245fac45.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/3e1bd339-386e-b2eb-fb3e-17e284362633.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/65ed5b5c-8af4-9118-dd66-c412f5f82e05.png'
                },

                 {
                    url:'http://g.hongshantong.com/upload/webuploader/06508ee6-f5f9-0c1e-51ef-768c7a1ef300.png'
                },

                 {
                    url:'http://g.hongshantong.com/upload/webuploader/ca27b2e5-f4c8-c26a-1b49-d26dd4f8b2c7.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/e21d2764-798b-e837-bda6-5d56843809e5.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/b511ee01-10e8-a459-a385-fefcd9e03036.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/541586d6-f344-93d8-0843-41c69b284130.png'
                },
                 {
                    url:'http://g.hongshantong.com/upload/webuploader/6aca92ed-03c7-82c2-477d-cf1c87e0323f.png'
                }
            ]
        }
    },
    created(){
        this.gelum()
    },
    methods:{
        gelum(){
    let newDataList = []
    let current = 0
    if(this.getLunbo && this.getLunbo.length>0){
      for(let i=0;i<=this.getLunbo.length-1;i++){
        if(i%12 !== 0 || i === 0 ){
          if(!newDataList[current]){
            newDataList.push([this.getLunbo[i]])
          }else{
            newDataList[current].push(this.getLunbo[i])
          }
        }else{
          current++
          newDataList.push([this.getLunbo[i]])
        }
      }
    }
    this.getLunbo = [...newDataList]
        }
    }
}
</script>
<style>
.el-carousel__button{                 
        width: 10px;
        height: 10px;
        background: #DADCE0;
        border-radius: 50%;
    }
.el-carousel__indicator.is-active button {
    opacity: 1;
    background: #108CEE;
}
</style>
<style lang="scss">
    .homePage{
        .homePage-first{
            width: 100%;
            .first-content{
                width: 1240px;
                margin: 0 auto;
                height: 555px;
                .content-img{
                    margin-top: 45px;
                    display: flex;
                    justify-content: space-between;
                }
            }
        }
        .homePage-first1{
            width: 100%;
            background: #EBF3FE;
            .first-content1{
                width: 1240px;
                margin: 0 auto;
                height: 595px;
                .content-img1{
                    display: flex;
                    justify-content: space-between;
                }
            }
        }
        .homePage-first2{
            width: 100%;
            .first-content2{
                width: 1240px;
                margin: 0 auto;
                height: 455px;
                .content-img2{
                    margin-top: 45px;
                    display: flex;
                    justify-content: space-between;
                }
            }
        }
        .homePage-first4{
            width: 100%;
            .first-content4{
                width: 1240px;
                margin: 0 auto;
                height: 510px;
                .content-img4{
                    display: flex;
                    justify-content: space-between;
                }
            }
        }
        .homePage-first8{
            width: 100%;
            background: #EBF3FE;
            .first-content8{
                width: 1240px;
                margin: 0 auto;
                height: 570px;
                .content-img8{
                    display: flex;
                    justify-content: space-between;
                }
            }
        }
        .homePage-first5{
            width: 100%;
            
            .first-content5{
                width: 1240px;
                margin: 0 auto;
                height: 475px;
                  background: #EBF3FE;
                .content-img5{
                    margin-top: 45px;
                    display: flex;
                    justify-content: space-between;
                }
            }
        }
        .homePage-first7{
            width: 100%;
            .first-content7{
                width: 1240px;
                margin: 0 auto;
                height: 475px;
                .content-img7{
                    margin-top: 45px;
                    display: flex;
                    justify-content: space-between;
                }
            }
        }
        .homePage-first6{
            width: 100%;
            background: #EBF3FE;
            .first-content6{
                width: 1240px;
                margin: 0 auto;
                height: 300px;
                .content-img6{
                    margin-right: 15px;
                    height:300px;
                    text-align: center;
                    justify-content: space-between;
                      .el-carousel__container {
                        position: relative;
                        height: 245px;
                    }
                }
            }
        }
    }
    .el-car-item {
    width: 100%;
    .top-img{
      width: 180px;
      margin-right: 20px;
      cursor: pointer;
      margin-top: 12px;
    }
  }

</style>